import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { DEFAULT_COLORS } from 'constants/colors';

const PlusIcon = ({ fill, height, width, viewBox, ...rest }) => {
    return (
        <SvgIcon cursor="pointer" width={width} height={height} viewBox={viewBox} {...rest}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2.51472C12.5523 2.51472 13 2.96243 13 3.51472V20.4853C13 21.0376 12.5523 21.4853 12 21.4853C11.4477 21.4853 11 21.0376 11 20.4853V3.51472C11 2.96243 11.4477 2.51472 12 2.51472Z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.51471 12C2.51471 11.4477 2.96242 11 3.51471 11L20.4853 11C21.0376 11 21.4853 11.4477 21.4853 12C21.4853 12.5523 21.0376 13 20.4853 13L3.51471 13C2.96242 13 2.51471 12.5523 2.51471 12Z"
                fill={fill}
            />
        </SvgIcon>
    );
};

PlusIcon.propTypes = {
    fill: string,
    height: string,
    width: string,
    viewBox: string,
};

PlusIcon.defaultProps = {
    fill: DEFAULT_COLORS.BLACK,
    height: '24',
    width: '24',
    viewBox: '0 0 24 24',
};

export default PlusIcon;
